import script from "./CustomInputFile.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomInputFile.vue?vue&type=script&setup=true&lang=js"

import "./CustomInputFile.vue?vue&type=style&index=0&id=4b747ac2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b747ac2"]])

export default __exports__